import { useInfiniteQuery } from '@tanstack/react-query';

import {
  BankAccountListSortType,
  getBankAccountsList,
} from '@/lib/coloc-api/admin';
import { useDebounce } from '@/hooks/use-debounce';
import { useColocApi } from '@/hooks/use-coloc-api';

const useGetBankAccountsInfinite = (params: { searchQuery?: string }) => {
  const { setPage, setPageLimit, page, pageLimit } =
    useColocApi<BankAccountListSortType>()!;
  const debouncedSearchQuery: string = useDebounce(
    params.searchQuery ?? '',
    500
  );

  const fetch = useInfiniteQuery({
    queryKey: ['getBankAccounts', debouncedSearchQuery, page, pageLimit],
    queryFn: ({ pageParam = 1 }) =>
      getBankAccountsList({
        page_limit: 100,
        ...(pageParam && { page: pageParam }),
        ...(debouncedSearchQuery &&
          debouncedSearchQuery !== '' && { query: debouncedSearchQuery }),
      }),
    keepPreviousData: true,
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.data.pagination.total_pages > pages.length) {
        return pages.length + 1;
      }

      return undefined;
    },
  });

  return {
    pageLimit,
    setPageLimit,
    fetch,
    setPage,
  };
};

export { useGetBankAccountsInfinite };
